import { Controller } from 'stimulus'
import Swiper, { Scrollbar } from 'swiper/core';

Swiper.use([Scrollbar]);

export default class extends Controller {
  static targets = ['container', 'slides', 'slide', 'next', 'prev', 'scrollbar', 'pagination']

  connect() {
    if (this.slideTargets.length === 0) {
      // If no slides are specified, assume the direct children are slides, and add classes
      Array.from(this.slidesTarget.children).forEach(child => child.classList.add('swiper-slide'))
    }
    this._swiper = new Swiper(this.containerTarget, {
      autoplay: false,
      loop: false,
      scrollbar: { el: this.scrollbarTarget, hide: false },
      slidesPerView: 'auto',
      spaceBetween: 30,
      freeMode: true,
      centerInsufficientSlides: true,
      initialSlide: 1,
    })
  }
}
